import { PerformanceLabel } from "app/performance/PerformanceLabel/PerformanceLabel";
import React from "react";
import { Box, DescriptionListEntry, DescriptionListTable } from "app/layout/components";

import "./styles.scss";
import { Headline, VisualHeadlineSize } from "app/layout/Headline/Headline";

export interface PerformanceListProps {
    headline: string;
    items: {
        label: string;
        value: number;
    }[];
}

/**
 * Renders a list of labels with percentage indicators on the right.
 */
export const PerformanceList = ({ headline, items }: PerformanceListProps) => {
    return (
        <Box className="performanceList" alternateBackground>
            <Headline semanticSize={0} visualSize={VisualHeadlineSize.SMALL} >{headline}</Headline>
            <DescriptionListTable>
                {items.map(({ label, value }, i) => (
                    <DescriptionListEntry key={i} term={label} details={<PerformanceLabel value={value} />} />
                ))}
            </DescriptionListTable>
        </Box>
    );
};
